import { companyName, version } from "./../../version";
import { NAVColumnsList } from "../../Pages/Dashboard/NavColumnsList";
import { SidebarSkel } from "../../Pages/Dashboard/ScheletonBlock";
import { Avatar } from "../MiscComponent/PrimitiveComponent";

export function CustomerSidebar ({ loading, sidebarOpen, mode, isPaid, data, changeMode, navigate, tab }) {
    const navItems = NAVColumnsList.filter(({ feature, key }) => {
      if (key === "fup") return data?.serviceStatus?.fup?.visible === true
      return !feature || data?.profile?.[feature] === true
    })
    return (<>
            <aside className={`sidebar ${ sidebarOpen ? "open" : "" }`}>
              {loading ? <SidebarSkel /> : (
                <>
                  {/* User chip */}
                  <div className="user-chip">
                    <Avatar name={`${data.firstname} ${data.lastname}`} />
                    <div style={{ minWidth:0 }}>
                      <div style={{ fontSize:13, fontWeight:600, color:"var(--txt)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{data.firstname} {data.lastname}</div>
                      <div className="mono" style={{ fontSize:11, color:"var(--txt3)" }}>{data.customerId||data.customer_id}</div>
                    </div>
                  </div>

                  {/* Demo toggle */}
                  <div className="pill-surface" style={{ marginBottom:12 }}>
                    <div style={{ fontSize:11, fontWeight:600, color:"var(--txt3)", textTransform:"uppercase", letterSpacing:"0.06em", marginBottom:8 }}>Tipe Tagihan</div>
                    <div className="mode-toggle">
                      {mode !== "inv" ?
                        <button
                          className={`mode-btn ${mode === "psb" ? "active" : ""}`}
                          disabled
                          onClick={()=>changeMode("psb")}
                        ><i className="fa fa-building"></i> Instalasi</button>
                        : <button
                          className={`mode-btn ${mode === "inv" ? "active" : ""}`}
                          disabled
                          onClick={()=>changeMode("inv")}
                        ><i className="fa fa-file-invoice-dollar"></i> Langganan</button>
                      }
                    </div>
                  </div>

                  {/* Nav */}
                  <nav style={{ display:"flex", flexDirection:"column", gap:2, flex:1 }}>
                    {navItems.map(({ key, icon, label }) => (
                      <button key={key} className={`nav-link-item ${tab === key?"active":""}`} onClick={()=>navigate(key)}>
                        <span className="nav-icon">
                           <i className={icon}></i>
                        </span>
                        <span>{label}</span>
                        {key === "billing" && !isPaid && (
                          <span className="badge badge-danger ms-auto" style={{ fontSize:10, padding:"2px 7px" }}>!</span>
                        )}
                      </button>
                    ))}
                  </nav>

                  {/* Footer */}
                  <div style={{ paddingTop:14, borderTop:"1px solid var(--border)", textAlign:"center" }}>
                    <div style={{ fontSize:11, color:"var(--txt3)" }}> &copy; {1900 + new Date().getYear()} {companyName}</div>
                    <div style={{ fontSize:11, color:"var(--txt3)" }}>{version}</div>
                  </div>
                </>
              )}
            </aside>
    </>)
}
